export enum UnavailabilityType {
  Unknown = 0,
  Disease = 1,
  WorkAccident = 2,
  LegalLeave = 3,
  ExtraLegalLeave = 4,
  PublicHoliday = 5,
  CompensatoryRest = 6,
  ShortLeave = 7,
  UrgentLeave = 8,
  ParentalLeave = 9,
  ThematicLeave = 10,
  TrainingLeave = 11,
  UnjustifiedAbsence = 12,
  Other = 13,
}
